import React from 'react'
import t from '../Language/language'
import trainingImage from '../../images/training-video.png'
import trainingImagefrench from '../../images/training-video-french.png'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'

export default class Training extends React.Component {
  constructor (props) {
    super()
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage()
    }
    this.authService = new AuthenticationService(Config.authBaseUrl)
  }

  render () {
    return (<div>
      {this.renderTrainingSection()}
    </div>)
  }

  renderTrainingSection () {
    const language = this.state.currentLanguage
    const trainingPortalUrl = Config.trainingPortalBaseUrl + this.authService.getToken();
    if (!this.authService.isAdmin()) {
      return (<div className='trainings'>
        <div className='trainingContent'>
          <h3> <a href={trainingPortalUrl} target='_blank'>{t[language].trainingBannerLearnMore}</a> </h3>
          <span>{t[language].trainingBannerDescription} </span><br />
          <br />
          <a className='training' href={trainingPortalUrl} target='_blank'>{t[language].trainingBannerPortalLink}</a>
        </div>
        <div className='trainingImage'>
          <a href={trainingPortalUrl} target='_blank'><img src={language===1 ? trainingImagefrench : trainingImage} /></a>
        </div>

      </div>)
    } else {
      return (<div />)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Welcome/Training.js